
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';

import { ToastContainer, notify } from '../../libraries/notifications';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Calendar from 'react-calendar';
import Button from '../../components/commons/Button';

import { isEmptyObject , getOwner, setTimeZeroDateWithTZ } from '../../libraries/utils';
import MessagesActions from '../../context/messages/actions'

import bookingsActions from '../../context/bookings/actions';


import 'react-calendar/dist/Calendar.css';
import Icon from '../../libraries/icons';
import Loader from '../../components/commons/Loader';
import { compareAsc, getDate, isToday } from 'date-fns';

function BookingElement({ booking, route, left, ...rest }) {
  return (
    <div onClick={rest.onClick}>
      <div className={"flex items-center badge rounded-lg mb-3 p-3  " 
        + ( (!(rest.selectedId === booking.id)) && 
        ((booking.type === config.TRANSACTIONS.BOOK.SUB_TYPE.VISIT) ? "badge-success" : "badge-warning")) }>
        
      <div className="flex flex-col flex-auto">
        <div className="font-semibold">
          <Icon className="h-4 w-4 mr-1 inline-block" name="location_marker" />
          {booking.json_data.location ? booking.json_data.location.name : "Videollamada"}
        </div>
      </div>
    </div>
    </div>
  )
}

class BookingCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      renderHistory: true,
      slots:[
       
      ],
      selectedDate: null,
      selectedTime: null,
      today: new Date(),
    }
  }
  
  componentDidMount() {
    if (isEmptyObject(this.props.location.state)) { 
      history.push(config.ROUTES.HOME);
    } else {
      const { appointment_type, professional } = this.props.location.state;
      this.setState({appointment_type,professional});
      this.getData()
    }
  }

  getData = async () => {
    await this.getAvailability({ date: setTimeZeroDateWithTZ(new Date()) });
    this.onClickCalendarDay(this.state.today)
  }

  selectTime(time){
    this.setState({selectedTime:time})
  }

  selectSlot(slot){
    this.setState({selectedSlot:slot})
  }

  selectBooking(booking){
    this.setState({selectedBooking: booking})
  }

  getAvailability = async (data) => {
    await this.props.onGetAvailability({ type: 'book', date: data.date, owner: getOwner(this.state.professional) });
    if (this.props.bookings.error) { 
      notify(this.t(this.props.bookings.error.message));
    } else {
      //this.setState({availability: [this.props.bookings.availability,this.props.bookings.availability]})
      
      const av1 = JSON.parse(JSON.stringify(this.props.bookings.availability));
      if(av1.booking){
        av1.booking.id = "asdfgh123456"
      }
      
      this.setState({availability: [this.props.bookings.availability]})
      this.selectBooking(this.state.availability[0].booking)
      
      //const { availability } = this.props.bookings.availability;
      //availability.forEach(av => {
      //  const { booking, availability } = av;
      //  if (av.length && av) {
      //    this.setState({slots:av[0].time_slots})
      //  }  
      //})
      
      const { booking, availability } = this.props.bookings.availability;
      if (availability?.length && availability) {
        if(booking.type === this.state.appointment_type){
          this.setState({slots:availability[0].time_slots})
        }
      }
    }
  }

  gotoBack = () => {
    history.push(config.ROUTES.PROFESSIONAL.replace(':id', this.state.professional.id));
  }

  onContinue = async () =>{
    this.setState({renderHistory:false})
    if(!this.state.selectedTime || !this.state.selectedDate || this.state.selectedTime === ""){
      notify(this.t("Seleccione un horario y una fecha"));
    } else {

      history.push({
        pathname: config.ROUTES.BOOKING.CLINIC_HISTORY,
        state: {
          professional: this.state.professional,
          appointment_type: this.state.appointment_type,
          date: this.state.selectedDate,
          time: this.state.selectedTime,
          slot: this.state.selectedSlot,
          appointment_location: this.state.selectedBooking.json_data.location,
        }
      })
    }
  }

  onClickCalendarDay = (value) => {
    this.getAvailability({ date: setTimeZeroDateWithTZ(value) });
    this.selectTime(null)
  }

  render() {
    //if (!location) return null;
    const {slots, availability, appointment_type, selectedBooking, renderHistory} = this.state
    const checkIfHourHasPassed = (start_time) => {
      let now = new Date()
      let date_start_time = new Date()
      let hour = start_time.split(":")[0]
      let minutes = start_time.split(":")[1]
      date_start_time.setHours(hour)
      date_start_time.setMinutes(minutes)
      if(compareAsc(now, date_start_time) === -1){
        return false
      } else{
        return true
      }
    }
  
      return (
      <LayoutSmall
        main={{ className: "bg-base-200"}}
        header={{
          title: this.t("Programar consulta"),
          className: "",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="h-10 bg-primary"></section>
        <section className="section-card z-20 relative">
          <div>
            <Calendar
                onChange={(v)=>{this.setState({selectedDate:v})}}
                value={this.state.selectedDate}
                minDate={this.state.today}
                locale="es"
                calendarType="US"
                defaultValue={this.state.today}
                tileDisabled={({activeStartDate, date, view }) =>{
                   let fechas_disabled = []
                   //desactivar sabados y domingos y fechas en fecha prueba
                   //return (date.getDay() === 0 || date.getDay() === 6 || fechas_disabled.some(f => f))
                    return false
                  }}
                prev2Label={null}
                next2Label={null}
                showNeighboringMonth={false}
                showWeekNumbers={false}
                onActiveStartDateChange={({ activeStartDate, value, view }) => {}}
                view="month"
                onClickDay={(v) => this.onClickCalendarDay(v)}
            />
          </div>
          <section className="mt-10 text-center">
          {!this.state.selectedDate && <div>Seleccione una fecha en el calendario</div>}
            {this.state.selectedDate && <>
              {/*(av.booking.json_data.location ? <div>{av.booking.json_data.location.name}</div> : null)*/}
              {(this.state.appointment_type === config.TRANSACTIONS.BOOK.SUB_TYPE.VISIT) && 
                <><h2>{this.t("Direcciones")}</h2>
                {availability && availability.map((av, index) => {
                  if(av.booking && av.booking.type === appointment_type){
                    return (
                        <span key={index} >
                          <BookingElement booking={av.booking} onClick={() => {this.selectBooking(av.booking)}} 
                            selectedId={selectedBooking && selectedBooking.id}/>
                        </span>
                      )
                  } else {
                    return null;
                  }
              })}</>}
              <h2>{this.t("Horarios")}</h2>
              <div className="scrolling-wrapper mt-4 gap-4">
              { this.props.bookings.loading && (<Loader containerClassName="mt-10"/>) }
              {!this.props.bookings.loading && !slots.length && (
                <small className="mx-auto">{this.t("No hay horarios disponibles para este día")}</small>
              )}
              {!this.props.bookings.loading && slots.map((slot, index) => {
                  if(checkIfHourHasPassed(slot.start_time) && isToday(this.state.selectedDate)) return null
                  return (
                    <div
                      key={`ts${index}`}
                      className={"card rounded-tr-none rounded-bl-none py-2 px-5 mb-4"
                        + ((slot.start_time !== this.state.selectedTime) ? " white" : " bg-primary text-white" )
                      }
                      onClick={() => {
                        this.selectTime(slot.start_time)
                        this.selectSlot(slot)
                      } }
                    >
                      <h4 className="items-center flex justify-between ">
                        <div>
                          <h3 className=" inline-block">{slot.start_time}</h3> 
                          {/* {ts.enabled} {ts.resources} {ts.owned} */}
                        </div>
                      </h4>
                    </div>
                );
                })}
              </div>
              <Button
                className="btn-accent btn-block mt-10"
                title={"CONFIRMAR"}
                onClick={this.onContinue}
                disabled={( !this.state.selectedDate || !this.state.selectedTime) && renderHistory === false } 
              />
              </>}
          </section>  
        </section>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    bookings: state.bookings.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAvailability: (params) => dispatch(bookingsActions.getAvailability(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(BookingCalendar));

